var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRubygems = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D34231",
  d: "m8.24 8.417-.011-.011-2.659 2.59 6.456 6.276 2.659-2.578 3.797-3.698-2.659-2.59v-.012H8.228l.012.023Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D34231",
  d: "M12 1.5 2.597 6.75v10.5L12 22.5l9.402-5.25V6.75L12 1.5Zm7.606 14.746L12 20.517l-7.606-4.27V7.73L12 3.46l7.606 4.27v8.516Z"
})));
export default SvgRubygems;